import React from 'react'
import { makeStyles } from '@zn-material-ui'
import loadingImg from '@assets/images/weblive/LiveList/loading.png'
import classNames from 'classnames'
import { transform } from '@utils/intl_lang'
export interface IProps {
  onFetch?: () => void
  style?: {}
  loading?: boolean
  abled?: boolean
  abledText?: string
  moreText?: string
  classnames?: string
}

const useStyles = makeStyles({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'calc(100% - 40px)',
    height: '50px',
    margin: '20px 20px',
    background: '#F5F5F5',
    fontSize: 16,
    color: '#999',
    letterSpacing: 0,
    textAlign: 'center',
    border: 'none',
    outline: 'none',
    decoration: 'underline',
    cursor: 'pointer',
  },
  loading: {
    display: 'block',
    width: 18,
    height: 18,
    marginRight: 6,
    animation: 'aLoading 3.5s linear infinite',
  },
  '@keyframes aLoading': {
    '0%': { transform: 'rotateZ(0deg)' },
    '100%': { transform: 'rotateZ(360deg)' },
  },
})
export default (props: IProps) => {
  const {
    onFetch = () => undefined,
    style,
    loading = false,
    abled,
    // '已全部加载完毕'
    abledText = transform('components_all_loaded'),
    // '查看更多'
    moreText = transform('more'),
    classnames = '',
  } = props
  const classes = useStyles()
  return (
    <button
      onClick={onFetch}
      className={classNames(classes.button, classnames)}
      style={style}
    >
      {loading && (
        <React.Fragment>
          <img className={classes.loading} src={loadingImg} alt="" />
        </React.Fragment>
      )}
      {/* '正在加载' */}
      <span>
        {loading
          ? transform('components_Loading')
          : abled
            ? moreText
            : abledText}
      </span>
    </button>
  )
}
